<div class="d-flex justify-content-center">
  <div class="spinner-border " role="status"></div>
  <span class="loader-position-info-message">{{message}}</span>
</div>